import { render, staticRenderFns } from "./salestax.vue?vue&type=template&id=241b9e5c&scoped=true&"
import script from "./salestax.vue?vue&type=script&lang=js&"
export * from "./salestax.vue?vue&type=script&lang=js&"
import style0 from "./salestax.vue?vue&type=style&index=0&id=241b9e5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241b9e5c",
  null
  
)

export default component.exports